import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CoreService } from '../../services/core.service';
import { UserModel } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.css']
})
export class UpdateProfileComponent implements OnInit {
  profile: any = {};
  userId: any;

  constructor(
    public dialogRef: MatDialogRef<UpdateProfileComponent>,
    private authService: AuthService,
    private coreService: CoreService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userId = data.id;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.getuser();
    });
  }

  getuser() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi(`/api/User/GetUser?userId=${this.userId}`).subscribe({
      next: (user: UserModel[]) => {
        this.coreService.isLoading.next(false);
        this.profile = user;
        this.profile.gender = this.profile.gender || ''; // Ensure gender key exists
        this.onPhoneNumberChange(this.profile.phoneNumber);
      },
      error: () => {
        this.coreService.isLoading.next(false);
      },
    });
  }

  formatDateForSql(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}T00:00`;
  }

  updateProfile() {
    this.coreService.isLoading.next(true);
    if (this.profile.dateOfBirth) {
      this.profile.dateOfBirth = this.formatDateForSql(new Date(this.profile.dateOfBirth));
    }

    this.coreService.postApi(`/api/User/UpdateUser`, this.profile).subscribe({
      next: (res: boolean) => {
        this.coreService.isLoading.next(false);
        if (res) {
          this.getuser();
          this.authService.setUser(this.profile);
          this.dialogRef.close(this.profile);
          Swal.fire({
            icon: 'success',
            title: 'Profile Updated Successfully!',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed to Update Profile',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000
          });
        }
      },
      error: () => {
        this.coreService.isLoading.next(false);
      },
    });
  }

  onPhoneNumberChange(value: string): void {
    const cleaned = value.replace(/\D/g, '').slice(0, 10);
    if (cleaned.length === 10) {
      this.profile.phoneNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length <= 6) {
      this.profile.phoneNumber = cleaned.replace(/(\d{3})(\d{0,3})/, '$1-$2');
    } else {
      this.profile.phoneNumber = cleaned.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (!this.profile.userName || !this.profile.email || !this.profile.gender) {
      return;
    }
    this.updateProfile();
    this.dialogRef.close(this.profile);
  }
}
